// extracted by mini-css-extract-plugin
module.exports = {"seeAllLink":"Companies_seeAllLink__WOoA4"};